import {Injectable} from '@angular/core';
import {LocalStorageService} from 'app/core/services/local-storage.service';
import {BehaviorSubject, Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {boolDevFlag} from 'test-helpers/dev-flags';

@Injectable({
    providedIn: 'root',
})
export class MonetizationTooltipStateService {
    private multipleTooltip$ = new BehaviorSubject(true);
    // public interface
    public isMultipleTooltip$: Observable<boolean> = this.multipleTooltip$;
    public multipleTooltipInc$: Observable<string> = this.multipleTooltip$.pipe(map(v => this.iconClass(v)));

    get multipleTooltip() {
        return this.multipleTooltip$.getValue();
    }

    set multipleTooltip(v: boolean) {
        this.multipleTooltip$.next(v);
    }

    toggleAppearanceTooltip() {
        this.multipleTooltip = !this.multipleTooltip;
        this.localStorageValue = this.multipleTooltip;
    }

    constructor(private localStorage: LocalStorageService) {
        this.multipleTooltip = this.localStorageValue;
    }

    /// public interface

    // localStorage
    private storageKey = 'apd_isMultipleTooltip';

    private get localStorageValue(): boolean {
        return boolDevFlag(this.storageKey, true, this.localStorage);
    }

    private set localStorageValue(appearance: boolean) {
        this.localStorage.setItem(this.storageKey, JSON.stringify(appearance));
    }

    // localStorage

    iconClass(v: boolean): string {
        return v ? 'icn-multi-tooltip' : 'icn-single-tooltip';
    }
}
